import React from "react";
import { useParams } from "react-router-dom";
import MemberList from "./memberList";
import InviteList from "./inviteList";
import AuthGroupList from "./authGroupList";
import useApi from "storybook-dashboard/utils/fetching";
import { TabWrapper, TabPanel, defaultTabStyles } from "../../components/TabComponents";
import { CompanyPermission } from "storybook-dashboard/permissions/company";
import useToken from "storybook-dashboard/auth/token";
import { Hide } from "storybook-dashboard/utils";

export default function CompanyMembers({ initFormFields }) {
  const { _companyId } = useParams();

  const { getClaims } = useToken();
  const claims = getClaims();
  const isSuperUser = claims?.get("is_superuser") || claims?.get("is_tenant_superuser") || false;

  const { data: company } = useApi(`/api/company/{_companyId}/`, { _companyId });
  const companyId = company?.get("uid");

  console.log("CompanyMembers", _companyId, companyId, company?.toJS());
  if (!company) return null;

  return (
    <div className="container-fluid">
      {/* Simplified TabWrapper with declarative TabPanels */}
      <TabWrapper
        defaultTab="users"
        navId="companyMembersTabs"
        contentId="companyMembersTabContent"
        customStyles={defaultTabStyles}
      >
        <CompanyPermission companyId={companyId} requiresAdmin={false} requiredActions={["READ_COMPANY_MEMBER"]}>
          <TabPanel tabId="users" label="Users">
            <MemberList companyId={companyId} initFormFields={initFormFields} />
          </TabPanel>
        </CompanyPermission>

        <CompanyPermission companyId={companyId} requiresAdmin={true}>
          <TabPanel tabId="invites" label="Pending User Invites">
            <InviteList companyId={companyId} />
          </TabPanel>
        </CompanyPermission>

        <Hide when={!isSuperUser}>
          <TabPanel tabId="authGroups" label="User Permissions">
            <AuthGroupList companyId={companyId} />
          </TabPanel>
        </Hide>
      </TabWrapper>
    </div>
  );
}
